import { api } from '@api/api2';
import { RequestPayload } from './types/request.payload';

export const requestUrl = 'area/objects/simple/list';

const getData = ({
  payload,
  signal,
}: {
  payload: RequestPayload;
  signal: AbortController['signal'];
}) => api.v4('get', requestUrl, payload, signal);

export const apiRequests = { getData };
